import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 17h-7l5-5-5-5h7V4H6v2l6.5 6L6 18v2h12z"
}), 'FunctionsTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/FunctionsTwoTone.js
// module id = 3963
// module chunks = 2